export const REVIEW_TAG = 'Цели';
